const createPopup = (obj) => {

  const popup = document.createElement('div');
  popup.classList.add('map-popup');

  // Image
  if (obj.ImagePath) {
    const popupImageHolder = document.createElement('div');
    popupImageHolder.classList.add('map-popup__image');

    const popupImage = document.createElement('img');
    popupImage.src = obj.ImagePath;

    popupImageHolder.append(popupImage);
    popup.append(popupImageHolder);
  }

  // Content
  const popupContent = document.createElement('div');
  popupContent.classList.add('map-popup__content');

  if (obj.Title) {
    const popupTitle = document.createElement('h2');
    popupTitle.classList.add('heading-xs', 'color--brand-ter', 'sign-s');
    popupTitle.innerHTML = obj.Title;
    popupContent.append(popupTitle);
  }

  if (obj.Description) {
    const popupDescription = document.createElement('div');
    popupDescription.classList.add('map-popup__description');
    popupDescription.innerHTML = obj.Description;
    popupContent.append(popupDescription);
  }

  if (obj.onButtonClick) {
    const popupZoomButton = document.createElement('button');
    popupZoomButton.classList.add('button', 'button--full');
    popupZoomButton.innerText = "Meer info";
    popupContent.append(popupZoomButton);

    popupZoomButton.onclick = obj.onButtonClick;
  }

  popup.append(popupContent);

  return popup;
}

export default createPopup;
